export default function (target: HTMLImageElement, path: string) {
  if ('IntersectionObserver' in window && target) {
    const fallback = target.src;

    let observer: IntersectionObserver;

    const imageObserver = (entries: Array<IntersectionObserverEntry>) => {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const lazyImage: Partial<HTMLImageElement> = entry.target;
          try {
            const image = new Image();
            image.src = path;
            image.onerror = () => {
              lazyImage.src = fallback;
              image.onerror = null;
              return;
            };
            lazyImage.src = path;
            observer.unobserve(target);
          } catch (e) {
            lazyImage.src = fallback;
            console.error(e);
          }
        }
      });
    };
    observer = new IntersectionObserver(imageObserver, {
      threshold: 0.1,
    });
    observer.observe(target);
  } else {
    // Possibly fall back to event handlers here
    console.log('Could not load intersection observer');
  }
}
